import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/core/Button';

import Plus from 'components/svg/Plus';
import Minus from 'components/svg/Minus';
import classnames from 'classnames';

import './zoomControls.scss';

export function ZoomControls({ onZoomIn, onZoomOut, className }) {
	return (
		<div className={classnames('zoom-controls', className)}>
			<Button
				primary={false}
				className="control-box"
				onClick={onZoomIn}
				ariaLabel="Zoom in"
			>
				<Plus />
			</Button>
			<hr />
			<Button
				primary={false}
				className="control-box"
				onClick={onZoomOut}
				ariaLabel="Zoom out"
			>
				<Minus />
			</Button>
		</div>
	);
}

ZoomControls.propTypes = {
	onZoomIn: PropTypes.func,
	onZoomOut: PropTypes.func,
	className: PropTypes.string,
};

export default ZoomControls;
